import {
    Banner,
    BannerDescription,
    BannerImage,
    BannerImageContainer,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    Box,
    Button,
    FluidImage,
    Link,
} from '@vp/swan';
import styled from 'styled-components';
import type { StaticImageData } from 'next/image';
import { __ } from '@99designs/i18n';
import { sendNavigationEvent, usePage } from '@99designs/tracking';
import heroImage from '../../images/logo-design-banner.webp';

const StyledBannerImage = styled(BannerImage)`
    img {
        height: 85%;
        object-fit: contain;
    }
`;

export function LogoBanner() {
    const { pageData } = usePage();

    return (
        <Box as="section" data-testid="logo-banner" marginTop="between-sections">
            <Banner
                backgroundColor="strong"
                textBoxHorizontalAlign="left"
                data-testid="logo-banner"
            >
                <BannerTextContainer px={7}>
                    <BannerText pr={{ sm: 0, md: 7 }} pl={0}>
                        <BannerTitle fontSize="x3large" fontWeight="bold">
                            {__('Logo dreams really do come true')}
                        </BannerTitle>
                        <BannerDescription>
                            {__(
                                'There are three ways to make your unique brand a reality. Start with our free logo maker, hire a professional designer or start a contest.'
                            )}
                        </BannerDescription>
                        <BannerLinks>
                            <Button
                                skin="secondary"
                                render={(props) => (
                                    <Link
                                        to="/logo-design"
                                        className={props.className}
                                        onClick={() =>
                                            sendNavigationEvent({
                                                ...pageData,
                                                category: 'Design Services',
                                                label: 'Content:Logo Design Banner',
                                                eventDetail:
                                                    '/design;/logo-design;Logo Design Banner;exploreLogoDesignOptions',
                                                navigationDetail: 'exploreLogoDesignOptions',
                                            })
                                        }
                                    >
                                        {props.children}
                                    </Link>
                                )}
                            >
                                {__('Explore your options')}
                            </Button>
                        </BannerLinks>
                    </BannerText>
                </BannerTextContainer>
                <BannerImageContainer>
                    <StyledBannerImage>
                        <FluidImage
                            src={(heroImage as unknown as StaticImageData).src}
                            alt=""
                            role="presentation"
                        />
                    </StyledBannerImage>
                </BannerImageContainer>
            </Banner>
        </Box>
    );
}
